//TODO:  DONE: Export the Footer
import React from "react";

const Footer = () => {
  return (
    <footer className="bg-info text-center pt-3 pb-2 mt-5 sticky-bottom">
      Engineered with ❤️ and made in 🇮🇳 by Snehomoy Maitra.
    </footer>
  );
};


export default Footer